import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { googleTagManageRequiredParamsSelector } from "./googleTagManagerSelectors";
import { pushGtmEvent } from "./googleTagManagerUtils";

export const useGTMEvent = (defaultParams = {}) => {
    const location = useLocation();
    const path = useMemo(() => `${location.pathname}${location.search}`, [location.pathname, location.search]);
    const requiredParams = useSelector(googleTagManageRequiredParamsSelector);

    const _pushGTMEvent = useCallback((params) => {
        pushGtmEvent({ ...requiredParams, path,  ...defaultParams, ...params })
    }, [defaultParams, path, requiredParams]);

    const handleGTMClick = useCallback((params) => _pushGTMEvent({ event: 'click', ...params }), [_pushGTMEvent])

    const handleGTMClickStartTradingButton = useCallback(() => handleGTMClick({ button: 'StartTrading' }), [handleGTMClick])

    const handleGTMClickLogoButton = useCallback(() => handleGTMClick({ button: 'Logo' }), [handleGTMClick]);

    return { pushGtmEvent: _pushGTMEvent, handleGTMClick, handleGTMClickStartTradingButton, handleGTMClickLogoButton }
}